import { SET_PATIENT_ADDRESS } from './constants';
import fetchWithRefreshV2 from './fetchWithRefreshV2';

export interface Request {
    _id?: string;
    pid: string;
    address: Address;
}

export interface Address {
    line1: string;
    line2: string;
    city: string;
    state: string;
    place_id: string;
    coordinates: string;
    pincode: string;
}

export interface Response {
    success: boolean;
    error: string;
}

export default (request: Request): Promise<Response> => {
    return fetchWithRefreshV2(SET_PATIENT_ADDRESS, {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
